import React from 'react';
import Chip from '@mui/material/Chip';
import FilterIcon from '@mui/icons-material/FilterList';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import FormInput from '../common/FormInput';
import {getReportFilterSettings} from '../../helpers/reports';

const ShowFilter = ({filterSetting, filter}) => {
  // if (!filterSetting) {
    return (
      <Chip label={`${filter.key}=${filter.value}`} color='default'/>
    );
  // }
  // return (
  //   <FormInput
  //     {...(filterSetting || {})}
  //     defaultValue={isNaN(parseInt(filter.value, 10)) ? filter.value : parseInt(filter.value, 10)}
  //     disabled={true}
  //     onChange={() => true}
  //   />
  // );
};

const ShowReportFilters = ({report}) => {
  const report_name = report?.report_name || null;
  console.log('REPORT', report);
  const filters = report?.filters || [];
  const filterSettings = getReportFilterSettings(report_name) || [];
  console.log('FILTER SETTINGS', filterSettings);
  return (
    <Stack direction='row' spacing={2} mb={2} flexWrap='wrap' alignItems='center'>
      <FilterIcon/>
      <Typography>
        Filters:
      </Typography>
      {!filters?.length && <Chip label='No filters applied' color='default'/>}
      {(filters || []).map(f => 
        <ShowFilter 
          filterSetting={filterSettings.find(fs => fs.name === f.key)} 
          filter={f}
        />
      )}
    </Stack>
  );
};

export default ShowReportFilters;